import Avatar from '@/models-ts/user/Avatar'
import UserInfo, { UserInfoFromServer } from '@/models-ts/user/UserInfo'
import Review from '../user/Review'

export default class GigFreelancer extends UserInfo {
  meta?: {
    reviews?: Array<Review>
  }

  constructor(data: GigFreelancer) {
    super(data)
    this.meta = data.meta
  }

  static fromServer(data: LX.GigFreelancer) {
    return new GigFreelancer({
      id: data.id,
      name: data.name,
      avatar: Avatar.fromServer(data.avatar),
      type: data.type,
      avgReviews: (data.profile?.avg_reviews || 0).toFixed(2),
      reviewsCount: data.reviews_count,
      is_customer_verified: false,
      bio: data.profile?.bio,
      meta: {
        reviews: (data.meta?.reviews || []).map(Review.fromServer),
      },
    })
  }
}
